import React from 'react';
import { Dialog } from '../../shared/custom-ui';
import RadiologistStats from './RadiologistStats';

interface RadiologistStatsModalProps {
    isOpen: boolean;
    onClose: () => void;
    radiologistId?: string;
    radiologistName?: string;
}

const RadiologistStatsModal: React.FC<RadiologistStatsModalProps> = ({
    isOpen,
    onClose,
    radiologistId,
    radiologistName,
}) => {
    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
            title={radiologistName ? `${radiologistName} — Workload Statistics` : 'Radiologist Workload Statistics'}
            description={
                radiologistName
                    ? `Real-time study assignments, pending tasks, and completion breakdown for ${radiologistName}`
                    : 'Real-time statistics showing study assignments, pending tasks, and completion status by modality'
            }
            className="w-[90vw] max-w-[1600px]"
        >
            <RadiologistStats radiologistId={radiologistId} radiologistName={radiologistName} />
        </Dialog>
    );
};

export default RadiologistStatsModal;
